module.exports = "/_next/static/images/6026963414e6bc044d3554cc3c33ff8c-man-looking-up-smiling-md@2x.jpg.webp";